import Apps from "@/components/AppTemplate/Apps";
import AppDetail from "@/views/MGT/AppDetail/AppDetail.vue";
export default {
  name: "Applist",
  components: {
    Apps,
    AppDetail
  },
  data() {
    return {
      showMore: true,
      detail: {
        visible: false,
        item: {}
      },
      scrollY: 0
    };
  },
  methods: {
    close() {
      this.detail.visible = false;
      this.onScrollto();
    },
    // 锚点定位
    onScrollto() {
      this.$nextTick(() => {
        this.$refs["app_list"].scrollTo(0, this.scrollY);
      });
    },
    jump(item) {
      this.scrollY = this.$refs["app_list"].scrollTop;
      this.detail.item = {
        ...item
      };
      this.detail.visible = true;
    }
  }
};